"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _NoResults = _interopRequireDefault(require("../../NoResults/NoResults"));

var _noInstalled = _interopRequireDefault(require("../../../assets/images/no-installed.png"));

var _EmptyTable = require("./EmptyTable.styles");

var EmptyTable = function EmptyTable(_ref) {
  var img = _ref.img,
      className = _ref.className,
      title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children,
      hasContainer = _ref.hasContainer,
      hasFooter = _ref.hasFooter,
      forError = _ref.forError,
      onRefresh = _ref.onRefresh;
  return (0, _jsxRuntime.jsx)(_NoResults["default"], {
    title: title,
    subtitle: subtitle,
    img: img,
    css: [_EmptyTable.styles.imgWrapper, hasContainer && _EmptyTable.styles.wrapper, hasFooter && _EmptyTable.styles.withFooter, process.env.NODE_ENV === "production" ? "" : ";label:EmptyTable;"],
    className: className,
    children: forError ? (0, _jsxRuntime.jsx)(_Button["default"], {
      onClick: onRefresh,
      children: "Refresh and try again"
    }) : children
  });
};

EmptyTable.propTypes = {
  className: _propTypes.string,
  img: _propTypes.string,
  title: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  subtitle: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),

  /**
   * Whether to add bg and box-shadow
   * pass true when there is footer or header atttached to table
   */
  hasContainer: _propTypes.bool,
  hasFooter: _propTypes.bool,
  forError: _propTypes.bool,
  onRefresh: _propTypes.func
};
EmptyTable.defaultProps = {
  className: undefined,

  /**
   * Show default img, title and subtitle
   */
  img: _noInstalled["default"],
  title: 'No search results for this input',
  subtitle: 'Check your input or try another term.',
  children: undefined,
  hasContainer: false,
  hasFooter: false,
  forError: false,
  onRefresh: function onRefresh() {}
};
var _default = EmptyTable;
exports["default"] = _default;
//# sourceMappingURL=EmptyTable.js.map